import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {PostNotificationEmailRequestDto} from '../models/PostNotificationEmailRequestDto';

@Injectable()
export class EmailService {

    constructor(private httpService: HttpService) {}

    createNotificationEmail(emailRequestDto: PostNotificationEmailRequestDto): Observable<Object> {
        const url = environment.ENDPOINTS.SEND_NOTIFICATION_EMAIL.replace('{:notificationId}', emailRequestDto.notificationId);
        return this.httpService.postJson(url, JSON.stringify(emailRequestDto));
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/email.service.ts